/* Office Walker 2A — mobile nav drawer toggle. */
(function () {
  'use strict';
  document.querySelectorAll('[data-ow2-nav]').forEach(function (root) {
    var burger = root.querySelector('[data-ow2-burger]');
    var drawer = root.querySelector('[data-ow2-drawer]');
    if (!burger || !drawer) return;

    function open() {
      drawer.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      root.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!root.classList.contains('is-open')) drawer.hidden = true; }, 260);
    }
    burger.addEventListener('click', function () {
      if (root.classList.contains('is-open')) { close(); } else { open(); }
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
  });
})();
